import { Alert, Box, Button, CircularProgress, TextField, Typography } from '@mui/material'

const ForgotPasswordForm = ({ form, status, handlers, t }: any) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            mt: 6,
            width: '100%'
        }}
    >
        {status.error && (
            <Alert severity="error" sx={{ mb: 2 }}>
                {status.error}
            </Alert>
        )}
        {status.success && (
            <Alert severity="success" sx={{ mb: 2 }}>
                {status.success}
            </Alert>
        )}
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: 'text.primary' }}>
            {t('forgotPasswordTitle')}
        </Typography>
        <Typography sx={{ mb: 3, color: 'text.secondary', fontSize: 16 }}>{t('forgotPasswordDesc')}</Typography>
        <TextField
            fullWidth
            placeholder={t('forgotPasswordPlaceholder')}
            variant="outlined"
            sx={{ mb: 4, width: 400, maxWidth: '100%' }}
            type="email"
            value={form.email}
            onChange={handlers.handlers.changeEmailHandler}
            error={!form.isEmailValid}
            helperText={!form.isEmailValid ? t('invalidEmail') : ''}
        />
        <Button
            variant="contained"
            sx={{ width: 140, fontWeight: 600, fontSize: 16, mb: 2 }}
            onClick={handlers.onForgotPassword}
            disabled={status.loading}
        >
            {status.loading ? <CircularProgress size={24} color="inherit" /> : t('send')}
        </Button>
        <Button
            variant="text"
            sx={{ color: 'brand.primary', textTransform: 'none', fontSize: 16, pl: 0 }}
            onClick={handlers.onBackToSignIn}
        >
            {t('backToSignIn')}
        </Button>
    </Box>
)

export default ForgotPasswordForm
